import Grid from '@mui/material/Grid';
import Title from "../Shared/Title";
import Pod from '../Shared/Pod';
import Match from "../Match/Match";
import { iconType } from '../Shared/Functions';

const RowConnection = props => {
    const type = iconType("Connections", props.item.SystemType)
    return (
        <Grid container className="ContainerRow">
            <Grid item xs={4}>
                <Title
                    row
                    href={`/connections/${props.item.Id}`}
                    systems={props.systems}
                    label={props.item.Name}
                />
            </Grid>
            <Grid item xs={4}>
                <Pod
                    icon={type.icon}
                    color={type.color}
                >
                    {type.label}
                </Pod>
            </Grid>
            <Grid item xs={4}>
                <Match type="jobs" matches={props.matches.jobs} />
            </Grid>
        </Grid>
    )
}

export default RowConnection;